shadow$provide[353] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Sprite:{enumerable:true, get:function() {
  return Sprite;
}}});
var require$three = require("three");
var require$_DOT__SLASH_base_DOT_js = require("./base.js");
var require$_DOT__DOT__SLASH_geometry_SLASH_spritegeometry_DOT_js = require("../geometry/spritegeometry.js");
class Sprite extends require$_DOT__SLASH_base_DOT_js.Base {
  constructor(renderer, shaders, options) {
    let f;
    super(renderer, shaders, options);
    let {uniforms} = options;
    const {material, position, sprite, map, combine, linear, color, mask, stpq} = options;
    if (uniforms == null) {
      uniforms = {};
    }
    const hasStyle = uniforms.styleColor != null;
    this.geometry = new require$_DOT__DOT__SLASH_geometry_SLASH_spritegeometry_DOT_js.SpriteGeometry({items:options.items, width:options.width, height:options.height, depth:options.depth,});
    this._adopt(uniforms);
    this._adopt(this.geometry.uniforms);
    const factory = shaders.material();
    const v = factory.vertex;
    v.pipe(this._vertexColor(color, mask));
    v.require(this._vertexPosition(position, material, map, 2, stpq));
    v.require(sprite);
    v.pipe("sprite.position", this.uniforms);
    v.pipe("project.position", this.uniforms);
    factory.fragment = f = this._fragmentColor(hasStyle, material, color, mask, map, 2, stpq, combine, linear);
    const edgeFactory = shaders.material();
    edgeFactory.vertex.pipe(v);
    edgeFactory.fragment.pipe(f);
    edgeFactory.fragment.pipe("fragment.transparent", this.uniforms);
    const fillFactory = shaders.material();
    fillFactory.vertex.pipe(v);
    fillFactory.fragment.pipe(f);
    fillFactory.fragment.pipe("fragment.solid", this.uniforms);
    const fillOpts = fillFactory.link({side:require$three.DoubleSide,});
    this.fillMaterial = this._material(fillOpts);
    const edgeOpts = edgeFactory.link({side:require$three.DoubleSide,});
    this.edgeMaterial = this._material(edgeOpts);
    this.fillObject = new require$three.Mesh(this.geometry, this.fillMaterial);
    this.edgeObject = new require$three.Mesh(this.geometry, this.edgeMaterial);
    this._raw(this.fillObject);
    this.fillObject.userData = fillOpts;
    this._raw(this.edgeObject);
    this.edgeObject.userData = edgeOpts;
    this.renders = [this.fillObject, this.edgeObject];
  }
  show(transparent, blending, order, depth) {
    this._show(this.edgeObject, true, blending, order, depth);
    return this._show(this.fillObject, transparent, blending, order, depth);
  }
  dispose() {
    this.geometry.dispose();
    this.edgeMaterial.dispose();
    this.fillMaterial.dispose();
    this.renders = this.geometry = this.edgeMaterial = this.fillMaterial = this.edgeObject = this.fillObject = null;
    return super.dispose();
  }
}

};